import runAfterPageLoad from "./runAfterPageLoad";

export default function appointmentsSidebarForm() {
  runAfterPageLoad(initAppointmentsSidebarForm);
}

function initAppointmentsSidebarForm() {
  if ($("#streams_select").length > 0) {
    initializeNewSelect2AppointmentsSidebarForm();
  }
}

function initializeNewSelect2AppointmentsSidebarForm() {
  const valuesProductForm = $("#streams_select").find(
    ".streams-filter__values:not(.select2-initialized)"
  );
  valuesProductForm.select2({
    multiple: true,
    placeholder: "Select streams for filtering",
    theme: "bootstrap",
    width: "100%",
  });

  valuesProductForm.addClass("select2-initialized");
}
